import { chunk } from "client/utils/chunk";
import { defaultColors } from "store/features/memeGenerator/data/defaultColors";
import { isColorActive } from "store/features/memeGenerator/isColorActive";
import { TextBox } from "store/features/memeGenerator/types";
import { Mode } from "../types";
import { ColorPickerButton } from "./ColorPickerButton/ColorPickerButton";
import { useColorList } from "./useColorList";

export interface ColorListProps {
    mode: Mode;
    textBox: TextBox;
}

export const ColorList = ({ textBox, mode }: ColorListProps) => {
    const { onColorChoose } = useColorList(textBox, mode);
    return (
        <div className="flex flex-col gap-4 p-4">
            <div className="flex items-center gap-2">
                <ColorPickerButton mode={mode} textBox={textBox} />
                {defaultColors.slice(0, 3).map((color) => (
                    <ColorChip key={color} textBox={textBox} color={color} mode={mode} onColorChoose={onColorChoose} />
                ))}
            </div>
            {chunk(defaultColors.slice(3), 4).map((chunk) => {
                return (
                    <div className="flex items-center gap-2">
                        {chunk.map((color) => (
                            <ColorChip
                                key={color}
                                textBox={textBox}
                                color={color}
                                mode={mode}
                                onColorChoose={onColorChoose}
                            />
                        ))}
                    </div>
                );
            })}
        </div>
    );
};

export interface ColorChipProps {
    mode: Mode;
    textBox: TextBox;
    color: string;
    onColorChoose: (color: string) => void;
}

export const ColorChip = ({ color, textBox, mode, onColorChoose }: ColorChipProps) => {
    const isActive = isColorActive(color, textBox, mode);

    return (
        <div
            className={`w-12 h-12 flex-shrink-0 flex items-center justify-center min-w-0 border-2 ${
                isActive ? "border-irBlue-200 dark:border-darkPrimary-100" : "border-irGray dark:border-darkSurface-400"
            } rounded-full`}
            key={color}
        >
            <button
                className="w-10 h-10 rounded-full"
                style={{
                    backgroundColor: color,
                }}
                onClick={() => onColorChoose(color)}
            />
        </div>
    );
};
